






































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'MailboxVerificationZohoConfirmationCodeFinder',

  data() {
    return {
      pollingForVerification: true,
      hasConfirmationCode: false,
      poller: null,
      pollCount: 0,
      pollIntervalInMS: 5000,
      pollMax: 12,
      confirmationCode: '',
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
  },

  watch: {
    pollCount: {
      handler(newValue) {
        if (newValue >= this.pollMax) {
          this.endPolling()
        }
      },
    },
  },

  beforeDestroy() {
    this.endPolling()
  },

  async created() {
    this.pollForVerificationEmail()
  },

  methods: {
    endPolling() {
      clearInterval(this.poller)
      this.pollingForVerification = false
    },
    pollForVerificationEmail() {
      this.hasConfirmationCode = false
      this.pollingForVerification = true
      this.pollCount = 0
      this.poller = setInterval(async () => {
        this.pollCount++
        await this.getMostRecentZohoConfirmationCode()
      }, this.pollIntervalInMS)
    },
    async getMostRecentZohoConfirmationCode() {
      try {
        const response = await MailboxesAPI.get_MostRecentZohoConfirmationCode(
          this.mailboxID,
        )
        this.confirmationCode = response.code
        this.hasConfirmationCode = true
        this.endPolling()
      } catch (err) {
        console.log('No confirmation code found.')
      }
    },
  },
})
